<template>
<div class="chapter">
<div class="inner_page">
<div id="Part01">
<p class="pt-num">P A R T   O N E<span epub:type="pagebreak" id="page15"></span></p>
<p class="pt-title">The German Auxiliary Cruiser <em class="italic">Guerre de Course</em></p>
<p class="noindent1">Recognising the importance to Britain of imported goods, the Imperial German Navy set a strategic goal to disrupt and destroy British trade. To accomplish such a task, the planners acknowledged that their limited number of appropriate vessels, essentially long-range cruisers, was insufficient. Thus they looked for other solutions. Britain, too, had a strategic imperative to disrupt and deny German trade; but first she had to determine the appropriate tactics.<span epub:type="pagebreak" id="page16"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_Part01.vue?90eae7a2